import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=4f8abe32&"
import script from "./LabelInput.vue?vue&type=script&lang=ts&"
export * from "./LabelInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports